import React, { Component } from 'react';
import { Box, Tooltip, Typography } from '@mui/material';
import i18n from '../../i18n';

class ArrayDetails extends Component {
    // props: value
    constructor(props) {
        super(props);
        this.state = {
            copiedIndex: null
        };
    }
    handleCopy = (text, index) => {
        navigator.clipboard.writeText(text).then(() => {
            this.setState({ copiedIndex: index });
            setTimeout(() => {
                this.setState({ copiedIndex: null });
            }, 2000);
        });
    };
    render() {
        const { value, label } = this.props;
        const { copiedIndex } = this.state;
        const items = Array.isArray(value) ? value : (value ? [String(value)] : []);
        if (items.length === 0)
            return (<Box sx={{ m: 1 }}>
                <Typography variant="subtitle1">
                    {i18n.t(`columns.${label}`)}
                </Typography>
                <Typography variant="body2">
                    No available data
                </Typography>
            </Box>);

        return (
            <Box sx={{ m: 1 }}>
                <Typography variant="subtitle1">
                    {i18n.t(`columns.${label}`)}
                </Typography>
                <Typography
                    variant="body1"
                    sx={{
                        wordBreak: 'break-word',
                        lineHeight: 1.6
                    }}
                >
                    {items.map((item, index) => (
                        <Tooltip
                            key={index}
                            title={
                                copiedIndex === index
                                    ? i18n.t('text.copied') || 'Copied!'
                                    : i18n.t('text.copy') || 'Copy'
                            }
                        >
                            <Box
                                component="span"
                                onClick={() => this.handleCopy(item, index)}
                                sx={{
                                    "cursor": 'pointer',
                                    "color":
                                        copiedIndex === index
                                            ? 'success.main'
                                            : 'text.primary',
                                    "transition": 'all 0.2s',
                                    '&:hover': {
                                        color: 'primary.main'
                                    }
                                }}
                            >
                                {item}
                                {index < value.length - 1 && ', '}
                            </Box>
                        </Tooltip>
                    ))}
                </Typography>
            </Box>

        );
    }
}

export default ArrayDetails;
